var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.$style.medias]},[_vm._l((_vm.media),function(item,index){return _c('ChatMediaItem',{key:item.id,attrs:{"media":item,"index":index,"is-mono-horizontal":_vm.isMonoHorizontal(item, index)}})}),(!_vm.isOpenable)?_c('div',{class:_vm.$style.blockOverlay}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }